/**
 * Série quotidienne : jours calendaires avec au moins une tentative (heure locale).
 */

export function getActivityDateKeys(attempts) {
  const daysWithActivity = new Set()
  if (!attempts || attempts.length === 0) return daysWithActivity
  attempts.forEach((attempt) => {
    if (!attempt.completedAt) return
    const date = attempt.completedAt.toDate ? attempt.completedAt.toDate() : new Date(attempt.completedAt)
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    daysWithActivity.add(`${y}-${m}-${d}`)
  })
  return daysWithActivity
}

/** Série courante : jours consécutifs avec activité en remontant depuis aujourd'hui (ou hier si pas d'activité aujourd'hui). */
export function calculateStreak(attempts) {
  const daysWithActivity = getActivityDateKeys(attempts)
  if (daysWithActivity.size === 0) return 0

  const sortedDates = Array.from(daysWithActivity).sort().reverse()
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const y = today.getFullYear()
  const m = String(today.getMonth() + 1).padStart(2, '0')
  const d = String(today.getDate()).padStart(2, '0')
  const todayKey = `${y}-${m}-${d}`

  let streak = 0
  let currentDate = new Date(today)
  if (sortedDates.includes(todayKey)) {
    streak = 1
    currentDate.setDate(currentDate.getDate() - 1)
  } else {
    currentDate.setDate(currentDate.getDate() - 1)
  }
  while (true) {
    const cy = currentDate.getFullYear()
    const cm = String(currentDate.getMonth() + 1).padStart(2, '0')
    const cd = String(currentDate.getDate()).padStart(2, '0')
    const dateKey = `${cy}-${cm}-${cd}`
    if (sortedDates.includes(dateKey)) {
      streak++
      currentDate.setDate(currentDate.getDate() - 1)
    } else {
      break
    }
  }
  return streak
}

const DAY_MS = 86400000

/** Plus longue suite de jours consécutifs avec activité sur l'historique fourni. */
export function calculateMaxStreakEver(attempts) {
  const daysWithActivity = getActivityDateKeys(attempts)
  if (daysWithActivity.size === 0) return 0
  const sorted = Array.from(daysWithActivity).sort()
  let maxRun = 1
  let run = 1
  for (let i = 1; i < sorted.length; i++) {
    const t0 = new Date(`${sorted[i - 1]}T12:00:00`).getTime()
    const t1 = new Date(`${sorted[i]}T12:00:00`).getTime()
    if (t1 - t0 === DAY_MS) {
      run++
      if (run > maxRun) maxRun = run
    } else {
      run = 1
    }
  }
  return maxRun
}
